module.exports = __webpack_public_path__ + "static/list_dot-4d0298441fbd5bffbc34fe794084f017.svg";